import { render, staticRenderFns } from "./AssetMove.vue?vue&type=template&id=1121df72&scoped=true"
import script from "./AssetMove.vue?vue&type=script&lang=ts"
export * from "./AssetMove.vue?vue&type=script&lang=ts"
import style0 from "./AssetMove.vue?vue&type=style&index=0&id=1121df72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1121df72",
  null
  
)

export default component.exports